import * as React from 'react';
import { connect } from 'react-redux';
import { SwordSearch, ConfigurationList, ConfigurationSwitchView } from 'src/app/Partials';
import { ConfigurationsDispatcher, GroupsDispatcher } from 'src/app/Container';
import { GlobalPrivateState, validateConfiguration, plateBuilder, warnings, QueryParameterState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';

import './ConfigurationList.page.scss';
import TroughBanner from 'src/app/Partials/TroughBanner/TroughBanner';
import FolderList from 'src/app/Partials/Configuration/List/FolderList';
import { userIsExternal } from 'src/app/Partials/Admin/utils';

export interface ConfigurationListPageProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
  trough: GlobalPrivateState['trough'];
  troughs: GlobalPrivateState['troughs'];
  order: GlobalPrivateState['order'];
  user: GlobalPrivateState['user'];
  params: QueryParameterState['params'];
  dispatch: Function;
}

export class ConfigurationListPageComponent extends React.Component<ConfigurationListPageProps> {

  componentDidMount() {
    this.clearConfigurationStates();
  }

  componentDidUpdate() {   
    this.clearConfigurationStates();
  }

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared('configurations'));
  }

  public render() {
    const { tab } = this.props.params;
    const isExternal = userIsExternal(this.props.user.result);

    return (
      <div className="page-configurations">
        <GroupsDispatcher />
        <div className="page-configuration-list pb-3">
          <div className="container">
            <SwordSearch />
            <div className="view-switcher">
              <div className="p-0">
                <ConfigurationSwitchView />
              </div>
            </div>
            {!isExternal && tab !== 'others' && tab !== 'archived' && (
              <FolderList limit={5} />
            )}
            <ConfigurationList />
            <TroughBanner />
          </div>
        </div>
      </div>
    );
  }

  private clearConfigurationStates(): void {
    const {
      checkout,
      configuration,
      dispatch,
      trough,
      troughs,
      order,
    } = this.props;

    if (checkout && checkout.result) {
      dispatch(requestAPIActions.loadCleared('checkout'));
    }
    
    if (configuration && configuration.result) {
      dispatch(requestAPIActions.loadCleared('configuration'));
    }

    if (trough && trough.result) {
      dispatch(requestAPIActions.loadCleared('troughs'));
    }

    if (troughs && troughs.result) {
      dispatch(requestAPIActions.loadCleared('troughs'));
    }

    if (order && order.result || order && order.error) {
      dispatch(requestAPIActions.loadCleared('order'));
    }

    // Clear all validations, calculations, warnings...
    this.props.dispatch(validateConfiguration.clear());
    this.props.dispatch(plateBuilder.clear());
    this.props.dispatch(warnings.clear());
  }
}

export const ConfigurationListPage = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
  configuration: state.configuration,
  trough: state.trough,
  troughs: state.troughs,
  order: state.order,
  user: state.user,
  params: state.queryState.params
}))(ConfigurationListPageComponent);